import styled from 'styled-components';

export const DetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  font-family: 'Roboto', 'Open Sans', 'Helvetica Neue', sans-serif;
  width: 1100px;
  margin: 20px auto;
  @media only screen and (max-width: 768px) {
    padding: 10px;
    max-width: 100vw;
  }
`;
export const Title = styled.div`
  padding: 0 0 20px 0;
  border-bottom: 1px solid #ebebf0;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  justify-content: space-between;
  h4 {
    font-weight: 500;
    font-family: Roboto, 'Open Sans', 'Helvetica Neue', sans-serif;
    color: #424b54;
    span {
      font-weight: 300;
      font-family: Roboto, 'Open Sans', 'Helvetica Neue', sans-serif;
      color: #424b54;
    }
  }
  @media only screen and (max-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 0 0 10px 0;
    margin-bottom: 10px;
    span {
      font-family: 'Roboto';
      font-size: 20px;
    }
    #btnBack {
      display: none !important;
    }
  }
`;
export const Directions = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Body = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0 0 0;
`;
export const BodyDetails = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
export const LeftDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
export const Bottom = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  button:first-child {
    padding: 0 20px;
    width: 156px;
    height: 53px;
    border: none;
    /* border-color: #ff574d; */
    background: #fff;
    color: #ff574d;
    border: 1px solid #ff574d;
    border-radius: 2px;
  }
  button {
    padding: 0 20px;
    width: 156px;
    height: 53px;
    border: none;
    background: var(--color-primary-light);
    color: #fff;
    border-radius: 2px;
  }
  @media only screen and (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const RightDetails = styled.div`
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`;
export const ModalConfirm = styled.div`
  width: 340px;
  height: 480px;
  padding: 30px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const DetailsClient = styled.div`
  min-width: 300px;
  min-height: 447px;
  background: #ffffff;
  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    min-height: 300px;
  }
`;

export const TitleDetailsClient = styled.div`
  height: 64px;
  background: #fafafc;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-left: 30px;
  display: flex;
  align-items: center;
  font-family: 'Roboto';
  font-size: 18px;
  font-weight: 500;
  color: #333333;
  @media only screen and (max-width: 768px) {
    font-size: 16px;
    padding-left: 20px;
    height: 56px;
  }
`;
export const BodyDetailsClient = styled.div`
  padding: 20px 30px 0px 30px;
  color: #333333;
  display: flex;
  flex-direction: column;
  span {
    font-weight: 300;
    font-size: 15px;
    line-height: 20px;
    margin-bottom: 5px;
  }
  label {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 768px) {
    padding: 10px 20px;
    span {
      font-weight: 300;
      font-size: 12px;
      line-height: 20px;
      margin-bottom: 5px;
    }
    label {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 20px;
    }
  }
`;
